/** @jsxImportSource theme-ui */

import React from 'react';
import Container, { ContainerProps } from '../Container';
import { FlexDirection } from '../utils/types';
import { ResponsiveStyleValue } from '@theme-ui/css';

export interface FlexContainerProps extends ContainerProps {
    justifyContent?: ResponsiveStyleValue<'center' | 'flex-start' | 'flex-end' | 'space-around' | 'space-between'>;
    direction?: FlexDirection;
    wrap?: ResponsiveStyleValue<'nowrap' | 'wrap' | 'wrap-reverse'>;
    shrink?: ResponsiveStyleValue<number>;
    grow?: ResponsiveStyleValue<number>;
    basis?: ResponsiveStyleValue<number | string>;
    gap?: ResponsiveStyleValue<string | number>;
}

export default function FlexContainer(props: FlexContainerProps): JSX.Element {
    const { justifyContent, direction, wrap, shrink, grow, basis, gap, sx, ...otherProps } = props;
    return (
        <Container
            sx={{
                display: 'flex',
                justifyContent: justifyContent,
                flexDirection: direction,
                flexWrap: wrap,
                flexShrink: shrink,
                flexGrow: grow,
                flexBasis: basis,
                gap,
                ...sx,
            }}
            {...otherProps}
        />
    );
}

FlexContainer.defaultProps = {
    direction: 'row',
    wrap: 'nowrap',
    justifyContent: 'flex-start',
    shrink: 1,
    grow: 0,
    basis: 'auto',
};
